import { MutationFunction } from '@apollo/client';
import { message } from 'antd';
import {
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutation,
  CredentialVerificationCaseV1BlobFileInput,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutation
} from '../../../../../../generated';
import { AuthResult } from '../../../../../shared/file-upload/azure-upload';

export const GetCredCaseAuthHeader = async (
  caseId: string,
  fileData: File,
  filename: string,
  getAuthHeaderForPdfFile: MutationFunction<
    CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutation,
    { input: CredentialVerificationCaseV1BlobFileInput }
  >,
  getAuthHeaderForImageFile: MutationFunction<
    CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutation,
    { input: CredentialVerificationCaseV1BlobFileInput }
  >
): Promise<AuthResult> => {
  if (fileData.type === 'application/pdf') {
    return getAuthHeaderForPdfFile({
      variables: {
        input: {
          caseId,
          fileName: filename,
          contentType: fileData.type,
          contentLength: fileData.size
        }
      }
    })
      .then((response) => {
        return {
          ...response?.data?.credentialVerificationCaseV1PdfFileCreateAuthHeader,
          ...{ isAuthorized: true }
        } as AuthResult;
      })
      .catch((error) => {
        console.error('Error uploading asset: ', error);
        message.error('Error getting authorization');
        return { isAuthorized: false } as AuthResult;
      });
  }

  return getAuthHeaderForImageFile({
    variables: {
      input: {
        caseId,
        fileName: filename.replace('.pdf', '-preview.png'),
        contentType: fileData.type,
        contentLength: fileData.size
      }
    }
  })
    .then((response) => {
      return {
        ...response?.data?.credentialVerificationCaseV1ImageFileCreateAuthHeader,
        ...{ isAuthorized: true }
      } as AuthResult;
    })
    .catch((error) => {
      console.error('Error uploading asset: ', error);
      message.error('Error getting authorization');
      return { isAuthorized: false } as AuthResult;
    });
};
